const UserClickedCopyBlogLink: string = "User_clicked_copy_blog_link";
export default UserClickedCopyBlogLink;
